import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import EndPoints from "../../Api/Endpoints";

export const fetchBloodGroupData = createAsyncThunk(
  "api/bloodgroup",
  async () => {
    const token = localStorage.getItem("other");
    const response = await fetch(EndPoints.PRISM_GET_BLOOD_GROUP, {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    });
    const data = await response.json();
    return data;
  }
);

const bloodgroupSlice = createSlice({
  name: "bloodGroup",
  initialState: {
    bloodgroupdata: null,
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchBloodGroupData.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchBloodGroupData.fulfilled, (state, action) => {
        state.loading = false;
        state.bloodgroupdata = Array.isArray(action.payload) ? action.payload : (action.payload?.data || []);
      })
      .addCase(fetchBloodGroupData.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      });
  },
});

export default bloodgroupSlice.reducer;